module.exports = __webpack_public_path__ + "static/img/brasao-pms.57ad4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brasao-pms.png
// module id = 8ZOn
// module chunks = 5